import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useMenuStore = defineStore('menu', {
  state: () => ({
    showThirdMenu: false,
    thirdMenuContent: null,
    thirdMenuType: null,
    isOperationInProgress: false,
    openGamesSidebar: false,
    secondaryMenuTab: null,
    showCreateTeamForm: false,
    leaguesFixturesOverlay: false,
    openCreateFixtureForm: false
  }),
  
  actions: {
    openRostersPanel() {
      this.openGamesSidebar = true
      this.secondaryMenuTab = 'rosters'
      this.showCreateTeamForm = false
    },
    openCreateTeamForm() {
      this.openGamesSidebar = true
      this.secondaryMenuTab = 'rosters'
      this.showCreateTeamForm = true
    },
    openCreateFixtureOverlay() {
      this.leaguesFixturesOverlay = true
      this.openCreateFixtureForm = true
    },
    openThirdMenu(content, type = 'fixture') {
      // Prevent rapid operations
      if (this.isOperationInProgress) {
        return
      }
      
      this.isOperationInProgress = true
      
      try {
        // Only update if content is valid
        if (content) {
          this.showThirdMenu = true
          this.thirdMenuContent = content
          this.thirdMenuType = type
        }
      } finally {
        // Reset operation flag after a short delay
        setTimeout(() => {
          this.isOperationInProgress = false
        }, 100)
      }
    },
    
    closeThirdMenu() {
      // Prevent rapid operations
      if (this.isOperationInProgress) {
        return
      }
      
      this.isOperationInProgress = true
      
      try {
        this.showThirdMenu = false
        // Clear content after animation completes
        setTimeout(() => {
          if (!this.showThirdMenu) {
            this.thirdMenuContent = null
            this.thirdMenuType = null
          }
        }, 300)
      } finally {
        // Reset operation flag after a short delay
        setTimeout(() => {
          this.isOperationInProgress = false
        }, 100)
      }
    }
  }
}) 